import React from 'react';
import PropTypes from 'prop-types';
import { FormActions } from '../../../util_components/form_layout';
import CustomCheckbox from '../../../util_components/custom_checkbox';
import CustomRadioButton from '../../../util_components/custom_radio_button';
import RequiredReasonTextarea from '../../../util_components/required_reason_textarea';
import TeacherCancelBucketPicker from '../../../util_components/teacher_cancel_bucket_picker';
import { IstTimePicker } from '../../../util_components/care_request/ist_time_picker';
import { shows_student_fields } from './repeat_cancel_rules';

function RepeatCancelForm(props) {
  const {
    is_group_cancel,
    cancel_all_future,
    cancelled_by_student,
    student_requested_at,
    cancelled_by_teacher,
    cancelled_by_admin,
    teacher_requested_at,
    requested_error,
    who_error,
    cancel_reason,
    cancel_reason_error,
    onToggleFuture,
    onToggleStudent,
    onToggleTeacher = () => {},
    onToggleAdmin = () => {},
    onRequestedAtChange,
    onTeacherRequestedAtChange = () => {},
    onReasonChange,
    onConfirm
  } = props;
  const student_fields = shows_student_fields(is_group_cancel, cancel_all_future);
  return (
    <div>
      <h4>Are you sure you want to cancel?</h4>
      <CustomCheckbox
        label="Cancel all future sessions"
        checked={cancel_all_future}
        onClick={onToggleFuture}
      />
      {student_fields ? (
        <>
          <div id="repeat-who-label" className="myt-form-label">
            Who cancelled? <span aria-hidden="true">*</span>
          </div>
          <div
            role="radiogroup"
            aria-labelledby="repeat-who-label"
            aria-required="true"
            aria-invalid={who_error ? 'true' : undefined}
            aria-describedby={who_error ? 'repeat-who-error' : undefined}
            className="myt-form-radios"
          >
            <CustomRadioButton
              label="Cancelled by Student"
              onRadioClick={onToggleStudent}
              selected={cancelled_by_student}
            />
            <CustomRadioButton
              label="Cancelled by Teacher"
              onRadioClick={onToggleTeacher}
              selected={cancelled_by_teacher}
            />
            <CustomRadioButton
              label="Cancelled by Admin"
              onRadioClick={onToggleAdmin}
              selected={cancelled_by_admin}
            />
          </div>
        </>
      ) : null}
      {student_fields && who_error ? (
        <p id="repeat-who-error" role="alert" className="myt-form-error">
          * Choose who asked to cancel: Cancelled by Student, Teacher or Admin
        </p>
      ) : null}
      {student_fields && cancelled_by_teacher ? (
        // a series has many classes, so no single category preview: only the request time
        <TeacherCancelBucketPicker
          requestedAt={teacher_requested_at}
          onRequestedAtChange={onTeacherRequestedAtChange}
          error={!!requested_error}
        />
      ) : null}
      {student_fields && cancelled_by_student ? (
        <div className="myt-field">
          <label className="myt-form-label" htmlFor="repeat-student-requested-at">
            Student requested at (IST)
          </label>
          <IstTimePicker
            id="repeat-student-requested-at"
            value={student_requested_at || ''}
            // the host reads an input-style event (name/value), as with the native field
            onChange={(value) =>
              onRequestedAtChange({ target: { name: 'student_requested_at', value } })
            }
            ariaRequired="true"
            ariaInvalid={requested_error ? 'true' : undefined}
            ariaDescribedBy={requested_error ? 'repeat-requested-at-error' : undefined}
            className="care-request-time"
          />
          {requested_error ? (
            <p id="repeat-requested-at-error" role="alert" className="myt-form-error">
              * {requested_error}
            </p>
          ) : null}
        </div>
      ) : null}
      <RequiredReasonTextarea
        value={cancel_reason}
        onChange={onReasonChange}
        placeholder="Why is this repeat being cancelled? (required)"
        error={cancel_reason_error}
        errorText="A reason (at least 3 characters) is required to cancel"
        height="80px"
      />
      <FormActions>
        <button onClick={onConfirm}>Confirm</button>
      </FormActions>
    </div>
  );
}

RepeatCancelForm.propTypes = {
  is_group_cancel: PropTypes.bool,
  cancel_all_future: PropTypes.bool,
  cancelled_by_student: PropTypes.bool,
  student_requested_at: PropTypes.string,
  cancelled_by_teacher: PropTypes.bool,
  cancelled_by_admin: PropTypes.bool,
  who_error: PropTypes.bool,
  teacher_requested_at: PropTypes.string,
  requested_error: PropTypes.string,
  cancel_reason: PropTypes.string,
  cancel_reason_error: PropTypes.bool,
  onToggleFuture: PropTypes.func.isRequired,
  onToggleStudent: PropTypes.func.isRequired,
  onToggleTeacher: PropTypes.func,
  onToggleAdmin: PropTypes.func,
  onRequestedAtChange: PropTypes.func.isRequired,
  onTeacherRequestedAtChange: PropTypes.func,
  onReasonChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default RepeatCancelForm;
